import { SET_LOGIN } from '../types/login.types';

export const setUserInfoSuccessfully = (userinfo) => {
    return { 
        type: SET_LOGIN,
        payload: userinfo
    };
}
